// extracted by mini-css-extract-plugin
export default {"root":"Frame-module_root-bKzVb"};